export const PostMethod = 'POST';
export const GetMethod = 'GET';
export const DeleteMethod = 'DELETE';
export const PutMethod = 'PUT';
export const PatchMethod = 'PATCH';
